interface Props {
  className?: string;
  showAmPm?: boolean;
  value?: string;
  onChange: (d: string) => void;
  disabled?: boolean;
}

const SimpleTimeInput = ({
  className,
  showAmPm = true,
  value,
  onChange,
  disabled,
}: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    onChange(inputValue);
  };

  if (showAmPm) {
    return (
      <input
        className={`input ${className}`}
        type='time'
        onChange={handleChange}
        disabled={disabled}
        value={value}
      />
    );
  }

  const displayValue24 = value || '';

  return (
    <input
      className={`input ${className}`}
      type='text'
      placeholder='HH:MM (24hr)'
      pattern='^([01]?[0-9]|2[0-3]):[0-5][0-9]$'
      maxLength={5}
      onChange={e => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/[^\d:]/g, '');
        if (inputValue.length === 2 && !inputValue.includes(':')) {
          inputValue += ':';
        }
        const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
        if (timeRegex.test(inputValue) || inputValue.length <= 5) {
          onChange(inputValue);
        }
      }}
      onBlur={e => {
        const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
        const match = e.target.value.match(timeRegex);

        if (match) {
          let [, hours, minutes] = match;
          hours = Math.min(parseInt(hours) || 0, 23)
            .toString()
            .padStart(2, '0');
          minutes = Math.min(parseInt(minutes) || 0, 59)
            .toString()
            .padStart(2, '0');

          const formattedTime = `${hours}:${minutes}`;
          onChange(formattedTime);
        }
      }}
      disabled={disabled}
      value={displayValue24}
    />
  );
};

export default SimpleTimeInput;
